<base-modal-component class="base-modal" [validation]="isValid()" (onConfirm)="save()" (onHidden)="onHidden()">
    <fields-list-component [fields]="fields" [value]="event"></fields-list-component>
</base-modal-component>
